/* global HTMLAuxFacetedFilterOptionElement */
import { AuxFacetedFilterOption } from "@blk/aladdin-react-components-es";
import React, { useEffect, useRef, useState } from "react";
export const InsFacetedFilterOption = (props) => {
    const ref = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);
    useEffect(() => {
        const handleClick = (event) => {
            setIsExpanded(!event.detail.expanded);
        };
        const element = ref.current;
        if (element) {
            element.addEventListener("panelClicked", handleClick);
        }
        return () => {
            if (element) {
                element.removeEventListener("panelClicked", handleClick);
            }
        };
    }, []);
    return React.createElement(AuxFacetedFilterOption, { ref: ref, isExpanded: isExpanded || props.isExpanded, isInnerAccordion: props.isInnerAccordion, type: props.type, overflow: props.overflow, positionOverflow: true, clear: props.clear, data: props.data, label: props.label, eventData: props.eventData, onFacetDataChanged: props.onFacetDataChanged, onClearClicked: props.onClearClicked });
};
